import { render, staticRenderFns } from "./lawyer-list.vue?vue&type=template&id=3fa3b1c8&scoped=true"
import script from "./lawyer-list.vue?vue&type=script&lang=js"
export * from "./lawyer-list.vue?vue&type=script&lang=js"
import style0 from "./lawyer-list.vue?vue&type=style&index=0&id=3fa3b1c8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa3b1c8",
  null
  
)

export default component.exports